/**
 * Dispatches an action to update form data in the Redux store.
 *
 * @param {Function} dispatch - The Redux dispatch function.
 * @param {string} formKey - The key identifying the form.
 * @param {string} fieldKey - The key identifying the field within the form.
 * @param {Object} data - The new data to update the field with.
 */
export const updateFormData = (dispatch, formKey, fieldKey, data) => {
  // return
  dispatch({
    type: "FORM_DATA_LIST",
    payload: {
      formKey,
      fieldKey,
      data,
    },
  });
};
// Dispatch function with corrected name and clarity
export const ClearSpecificForm = (dispatch, formKey) => {
  dispatch({
    type: "CLEAR_SPECIFIC_FORM",
    payload: {
      formKey,
    },
  });
};

// export const ClearMasterDropdown = (dispatch, formKey, masterData) => {

//   dispatch({
//     type: "CLEAR_MASTER_DROPDOWN",
//     payload: {
//       formKey,
//     },
//   });
//   let obj={}
//   for (let key in masterData){
// obj[key]=""
//   }
//   return obj
// };

export const Form_State = (value) => {
  console.log("Madjasdajhdashjdhasjkhdkjahda", "ChechDataSave");
  const obj = {
    CityMaster: "City_Master",
    StateMaster: "State_Master",
    CountryMaster: "Country_Master",
    ZoneMaster: "Zone_Master",
    AreaMaster: "Area_master",
    PincodeMaster: "Pincode_Master",
    GodownMaster: "Godwon_Master",
    DistrictMaster: "District_Master",
    NominalAccount: "Nominal_Account",
    VendorAccount: "Vendor_Account",
    CustomerAccount: "Customer_Account",
  };

  return obj[value];
};
